const en = {
  // Navigation
  nav_logo: "CHIEF",
  nav_what_is: "What is Chief?",
  nav_what_does: "What Does It Do?",
  nav_who_for: "Who Is It For?",
  nav_talk: "Talk to Chief",
  nav_home: "Home",
  nav_partnership: "Partnership Model",

  // Hero
  hero_title_1: "AI assistant that reads your data, answers your questions, and completes workflows",
  hero_title_2: "for your organization",
  hero_desc:
    "Chief instantly reads data from CRM, ERP, Excel, SQL, and other data sources. It answers your questions via WhatsApp, Telegram, or custom chatbot; monitors changes, generates alerts, and automatically initiates workflows. Chief plans, tracks, and completes the entire process for you.",
  hero_cta: "Talk to Chief",

  // How it works
  how_title_1: "How does",
  how_title_2: "Chief work?",
  how_desc:
    "Chief, the AI business assistant, manages the path from your data sources to workflow.",
  how_footer: "From Excel to ERP, all your data is at Chief's fingertips",

  // Data Sources
  data_crm: "CRM",
  data_erp: "ERP",
  data_excel: "Excel",
  data_sql: "SQL",
  data_memory: "Corporate Memory",

  // Outputs
  output_qa: "Q&A",
  output_notification: "Notifications",
  output_action: "Action Trigger",

  // Workflow
  workflow_title: "AI assistant that manages workflows",
  workflow_desc_1: "Chief is not just an analytical system.",
  workflow_desc_2:
    "You ask questions, get answers; processes advance automatically.",
  workflow_desc_3:
    "Right tasks go to the right people at the right time.",
  workflow_desc_4:
    "Teams work without waiting; operations run smoothly.",
  workflow_footer:
    "Chief automatically routes all tasks to the right person according to the workflow.",

  // Advantages
  advantage_time_title: "Saves Time",
  advantage_time_desc:
    "Eliminates manual tracking burdens. Workflows progress automatically. Reporting and approval processes are significantly shortened.",
  advantage_error_title: "Error-Free Processes",
  advantage_error_desc:
    "Prevents data entry errors. Every team works with the same accuracy and up-to-date information.",
  advantage_transparent_title: "Transparent Operations",
  advantage_transparent_desc:
    "Every task, approval, and report is traceable. Management and teams always have access to current information.",

  // Teams
  teams_title: "Chief is a real assistant for all teams",
  teams_desc:
    "It knows the needs of every role. Routes workflows to the right unit and the right person. Chief automatically manages the entire workflow in the background, enabling seamless operations.",

  role_clevel_title: "Strategic Control",
  role_clevel_desc:
    "Instant access to KPIs, no waiting for reports. Risk and profitability decisions are made using real-time data.",
  role_manager_title: "Team Performance Control",
  role_manager_desc:
    "Balances team workload and prevents delays. Approval processes flow automatically.",
  role_operation_title: "Seamless Process Management",
  role_operation_desc:
    "Tasks enter the flow in the right team, in the right order. Communication from field to headquarters works flawlessly.",
  role_sales_title: "More Proposals, More Revenue",
  role_sales_desc:
    "Automatic tasks for sales teams. Proposals are created and tracked on time.",
  role_marketing_title: "Campaigns Connect to Operations",
  role_marketing_desc:
    "Segmentation, insights, and customer actions unite in a single AI memory.",
  role_support_title: "Faster Resolution",
  role_support_desc:
    "Complaints and requests flow as tasks to business units. Satisfaction increases, lost customers decrease.",

  animation_title: "Chief routes tasks and completes work.",

  // Roles
  role_ceo: "CEO",
  role_cfo: "CFO",
  role_coo: "COO",
  role_cmo: "CMO",
  role_sales: "Sales",
  role_field: "Field Audit",
  role_production: "Production",
  role_quality: "Quality",

  // Task Animation
  task_1_title: "Proposal Task Created",
  task_1_subtitle: "Awaiting customer delivery",
  task_2_title: "Budget Approval Request",
  task_2_subtitle: "Moved to pre-approval flow",
  task_3_title: "Operation Task Scheduled",
  task_3_subtitle: "Resources being assigned",
  task_4_title: "Work Order Issued",
  task_4_subtitle: "Notification sent to line manager",
  task_5_title: "Quality Control Started",
  task_5_subtitle: "Sample analysis opened",
  task_6_title: "Field Task Assigned",
  task_6_subtitle: "Location information shared",
  task_7_title: "Campaign Brief Shared",
  task_7_subtitle: "Content production initiated",
  task_8_title: "Weekly Performance Report Ready",
  task_8_subtitle: "Forwarded for presentation approval",

  // Partner section
  partner_section_title: "Become a Chief partner",
  partner_section_desc:
    "Position Chief alongside your own solutions, offer your customers an AI-powered decision assistant. Grow together with revenue sharing, integration support, and co-marketing.",

  partner_tech_title: "Technology & integration partners",
  partner_tech_desc:
    "Integrate Chief into your ERP, CRM, BI, and custom software to offer your customers end-to-end decision support solutions.",

  partner_consulting_title: "Consulting & digital transformation firms",
  partner_consulting_desc:
    "Position Chief as part of your standard toolkit when providing process analysis, data projects, or digital transformation consulting.",

  partner_saas_title: "SaaS & product owners",
  partner_saas_desc:
    "Add an AI layer to your existing products. Chief makes products smarter with data reading, Q&A, and action triggering capabilities.",

  partner_cta_desc:
    "Explore the dedicated page for partnership model and details.",
  partner_cta_button: "Partnership Model",

  // Footer
  footer_desc:
    "Chief is an AI business assistant developed by Datafors. It reads your organizational data, automates workflows, and enables teams to work faster and error-free.",
  footer_links_title: "Links",
  footer_link_what: "What is Chief?",
  footer_link_what_does: "What Does It Do?",
  footer_link_who: "Who Is It For?",
  footer_link_partnership: "Partnership Model",
  footer_link_faq: "Frequently Asked Questions",
  footer_contact_title: "Contact",
  footer_email: "Email: talktochief@chiefai.com.tr",
  footer_phone: "Phone: +90 216 606 22 09",
  footer_office:
    "Office: Boğaziçi University Kandilli Technopark Istanbul · Turkey",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Use",
  footer_cookies: "Cookie Policy",
  footer_faq: "FAQ",
  footer_powered: "Powered by DataFors",
  footer_copyright:
    "© 2025 Datafors. All rights reserved.",

  // FAQ + Policies

  // Privacy Policy
  privacy_title: "Privacy Policy",
  privacy_intro:
    "Chief is an artificial intelligence assistant developed by Datafors. The security and privacy of users’ personal data is our priority.",
  privacy_collected_title: "Collected Data",
  privacy_collected_desc: "Chief may process the following data categories:",
  privacy_collected_1: "Identity information (Name, surname)",
  privacy_collected_2: "Contact information (Phone, email)",
  privacy_collected_3: "Corporate information (Company, position)",
  privacy_collected_4: "System data (Device used, IP address, cookies)",
  privacy_collected_5:
    "Operational data (Requests, work orders and actions performed through Chief)",
  privacy_usage_title: "Data Usage Purposes",
  privacy_usage_desc: "Collected data is processed to:",
  privacy_usage_1: "Provide services and manage workflows",
  privacy_usage_2: "Respond to your questions quickly",
  privacy_usage_3: "Improve product performance",
  privacy_usage_4: "Ensure security and verification",
  privacy_usage_suffix: "",
  privacy_sharing_title: "Data Sharing",
  privacy_sharing_desc:
    "Your data is not shared with third parties except in the following cases:",
  privacy_sharing_1: "Legal obligations",
  privacy_sharing_2: "Systems integrated with user consent",
  privacy_sharing_3: "Infrastructure service providers",
  privacy_security_title: "Data Security",
  privacy_security_desc: "Your data is stored in:",
  privacy_security_1: "Encrypted databases",
  privacy_security_2: "Access-controlled environments",
  privacy_security_suffix: "",
  privacy_retention_title: "Data Retention Period",
  privacy_retention_desc:
    "Your data is stored for the duration of the service relationship or as required by law.",
  privacy_rights_title: "Your Rights",
  privacy_rights_desc: "Under GDPR and KVKK, you have the right to:",
  privacy_rights_1: "Access your data",
  privacy_rights_2: "Request corrections",
  privacy_rights_3: "Request deletion or transfer",
  privacy_rights_4: "Object to processing",
  privacy_rights_suffix: "",
  privacy_contact_title: "Contact",
  privacy_contact_desc: "For any questions: privacy@datafors.com",

  // Terms
  terms_title: "Terms of Use",
  terms_updated: "Last Updated: January 2025",
  terms_intro: "By using Chief, you accept the following terms.",
  terms_service_title: "Service Scope",
  terms_service_desc:
    "Chief facilitates data access and manages workflows. Recommendations and actions generated by Chief are advisory; final decisions belong to the user.",
  terms_obligations_title: "User Obligations",
  terms_obligations_1: "Users must protect their account security.",
  terms_obligations_2: "Illegal, harmful, or misleading requests cannot be made.",
  terms_obligations_3: "Users are responsible for ensuring data accuracy.",
  terms_ip_title: "Intellectual Property",
  terms_ip_desc:
    "All designs, code, models, and visuals belonging to Chief are the property of Datafors and may not be copied without permission.",
  terms_access_title: "Access and Changes",
  terms_access_desc:
    "Datafors reserves the right to improve, suspend, or limit access to the service.",
  terms_liability_title: "Disclaimer",
  terms_liability_desc:
    "Chief’s recommendations are advisory. Users are responsible for commercial, legal, or operational outcomes.",
  terms_effective_title: "Effective Date",
  terms_effective_desc: "These terms are effective as of the date of publication.",

  // Cookie Policy
  cookies_title: "Cookie Policy",
  cookies_updated: "Last Updated: January 2025",
  cookies_intro:
    "Chief uses cookies to enhance user experience.",
  cookies_types_title: "Cookie Types",
  cookies_types_1: "Essential cookies",
  cookies_types_2: "Performance cookies",
  cookies_types_3: "Functional cookies",
  cookies_manage_title: "Managing Cookies",
  cookies_manage_desc: "Manage cookie usage from browser settings:",
  cookies_manage_1: "Accept cookies",
  cookies_manage_2: "Limit cookies",
  cookies_manage_3: "Block cookies",
  cookies_manage_note:
    "Some features may not work if cookies are disabled.",
  cookies_legal_title: "Legal Basis",
  cookies_legal_desc:
    "Cookie usage complies with GDPR, KVKK, and e-Privacy regulations.",

  // FAQ
  faq_title: "Frequently Asked Questions",
  faq_subtitle: "What you need to know about Chief",
  faq_q1: "What is Chief?",
  faq_a1:
    "An AI assistant that reads data, answers questions, and manages workflows automatically.",
  faq_q2: "What does Chief do?",
  faq_a2:
    "Analyzes data, routes tasks, manages processes, and produces insights.",
  faq_q3: "Which systems does Chief work with?",
  faq_a3:
    "CRM, ERP, SQL, Excel, API integrations, and internal corporate data sources.",
  faq_q4: "Which platforms support Chief?",
  faq_a4:
    "Web, mobile, WhatsApp, Telegram, and custom chatbot integrations.",
  faq_q5: "Is my data safe?",
  faq_a5:
    "Yes. All data is securely encrypted and access-controlled.",
  faq_q6: "Can I request a demo?",
  faq_a6:
    "Yes. Submit a request via the contact form or the 'Talk to Chief' button.",
  
  // Partnership
  partnership_hero_title_1: "Become a Partner",
  partnership_hero_title_2: "with Chief",
  partnership_hero_desc: "Position Chief alongside your solutions and offer AI-powered decision assistant to your customers. Grow together with revenue sharing, integration support, and joint marketing.",
  partnership_models_title: "Partnership Models",
  partnership_models_desc: "Choose the partnership type that fits your business model and become part of the Chief ecosystem.",
  partnership_tech_title: "Technology & Integration Partners",
  partnership_tech_desc: "Integrate Chief into your ERP, CRM, BI, and custom software to provide your customers with end-to-end decision support solutions.",
  partnership_tech_feature_1: "API and webhook integration",
  partnership_tech_feature_2: "Technical documentation support",
  partnership_tech_feature_3: "Joint customer success management",
  partnership_tech_feature_4: "Revenue sharing model",
  partnership_consulting_title: "Consulting & Digital Transformation",
  partnership_consulting_desc: "Position Chief as part of your standard toolkit when conducting process analysis, data projects, or digital transformation consulting.",
  partnership_consulting_feature_1: "Project-based licensing",
  partnership_consulting_feature_2: "Training and certification program",
  partnership_consulting_feature_3: "Pre-sales technical support",
  partnership_consulting_feature_4: "Joint marketing opportunities",
  partnership_saas_title: "SaaS & Product Owners",
  partnership_saas_desc: "Add an AI layer to your existing products. Chief makes your product smarter with data reading, Q&A, and action triggering capabilities.",
  partnership_saas_feature_1: "White-label solution options",
  partnership_saas_feature_2: "Embedded integration",
  partnership_saas_feature_3: "Per-customer pricing",
  partnership_saas_feature_4: "Technical integration support",
  partnership_benefits_title: "Partnership Benefits",
  partnership_benefits_desc: "The value and opportunities you'll gain as a Chief partner.",
  benefit_revenue_title: "Revenue Sharing",
  benefit_revenue_desc: "Competitive commission rates and sustainable revenue model",
  benefit_support_title: "Technical Support",
  benefit_support_desc: "Integration and pre-sales technical support team",
  benefit_marketing_title: "Joint Marketing",
  benefit_marketing_desc: "Co-marketing campaigns and content creation",
  benefit_training_title: "Training Program",
  benefit_training_desc: "Certification and continuous education opportunities",
  benefit_access_title: "Priority Access",
  benefit_access_desc: "Early access to new features and beta testing",
  benefit_community_title: "Partner Community",
  benefit_community_desc: "Networking and knowledge sharing with other partners",
  benefit_materials_title: "Sales Materials",
  benefit_materials_desc: "Ready-made presentations, demos, and sales documents",
  benefit_analytics_title: "Performance Tracking",
  benefit_analytics_desc: "Detailed reporting and analytics tools",
  partnership_process_title: "How to Become a Partner?",
  partnership_process_desc: "Join the Chief ecosystem through a simple and fast application process.",
  process_step_1_title: "Apply",
  process_step_1_desc: "Fill out the form or contact us",
  process_step_2_title: "Review",
  process_step_2_desc: "Our team will review your application within 2-3 business days",
  process_step_3_title: "Onboarding",
  process_step_3_desc: "Complete the training and integration process",
  process_step_4_title: "Get Started",
  process_step_4_desc: "Start offering Chief to your customers",
  partnership_cta_title: "Get Started Now",
  partnership_cta_desc: "Contact us to establish a partnership with Chief and offer AI-powered solutions to your customers.",
  partnership_cta_button: "Apply for Partnership"
};

export default en;
